import AddAllToCuratedButton from './AddAllToCuratedButton';
export default AddAllToCuratedButton;
export * from './AddAllToCuratedButton';
